<template>
  <Page :class="{ toggle: toggleSidebar }">
    <ManageCollectionItemModal
      v-if="isManageCollectionItemModalShowing"
      :collectionType="loadItem.collectionType"
      :itemId="loadItem.itemId"
      :onClose="onCloseManageCollectionItemModal" />
    <FilterSidebar
      class="sidebar"
      :enableFilterOption="['contentCategories', 'status']"
      v-if="toggleSidebar"
      :onClose="handleToggleSidebar" />
    <template v-slot:page-header>
      <div class="container">
        <div class="page-header">
          <div class="title-container">
            <div class="title">วิดีโอถ่ายทอดสด</div>
          </div>
          <div class="actions">
            <router-link :to="'/live/create'" class="btn btn-primary">
              <i class="fas fa-plus icon"></i> สร้าง<span class="d-none d-sm-inline-block">วิดีโอถ่ายทอดสด</span>
            </router-link>
          </div>
        </div>
      </div>
    </template>
    <div class="container">
      <PreloaderSection v-if="loadVideosListState.status ==='loading'" />
      <div>
        <!-- render content -->
        <Section v-if="loadVideosListState.status ==='success'">
          <template v-slot:section-filter>
            <div class="search-container">
              <input
                class="form-control form-control-search"
                :value="filter.q"
                placeholder="ค้นหาด้วยชื่อวิดีโอ"
                @change="onSearch" />
              <div
                class="filter-button ml-2"
                @click="handleToggleSidebar">
                <i class="fa fa-filter icon mr-2" />
                <span class="filter-label">ค้นหาขั้นสูง</span>
              </div>
            </div>
          </template>
          <!-- render content -->
          <template v-slot:section-body>
            <div v-if="!isEmpty()">
              <List>
                <template v-slot:list-header>
                  <div class="list-item-image"></div>
                  <div class="list-item-detail">
                    <div class="list-item list-item-primary title-information">
                      ชื่อ
                    </div>
                    <div class="list-item">เวลาเริ่มถ่ายทอดสด</div>
                    <div class="list-item list-item-create-at">เวลาจบถ่ายทอดสด</div>
                    <div class="list-item list-item-status">สถานะ</div>
                    <div class="list-item list-item-action"></div>
                  </div>
                </template>
                <template v-slot:list-body>
                  <div
                    class="list-item-container no-underline"
                    v-for="(item, itemIndex) in videos"
                    :key="item.id"
                    @click.stop="goToPageDetail(`/live/${item.id}`, itemIndex, $event)">
                    <div class="list-item-image">
                      <ImageView
                        :source="item.coverImage"
                        imageSize="cover160w90h" />
                    </div>
                    <div class="list-item-detail">
                      <div class="list-item list-item-primary title-information">
                        <div class="information-wrapper">
                          <div class="subtitle">
                            {{ getProgramName(item.program) }}
                          </div>
                          <div class="title">{{ item.title }}</div>
                        </div>
                        <span class="badge badge-live" v-if="item.type === 'live'">LIVE</span>
                      </div>
                      <div class="list-item">
                        {{ item.startLiveAt ? formatDateTime(item.startLiveAt) : '-'}}
                      </div>
                      <div class="list-item list-item-create-at">
                        {{ item.endLiveAt ? formatDateTime(item.endLiveAt) : '-' }}
                      </div>
                      <div class="list-item list-item-status">
                        <div class="badge badge-status" :class="item.status">
                          {{ item.status }}
                        </div>
                      </div>
                      <div class="list-item list-item-action">
                        <div class="action-container">
                          <router-link
                            class="btn btn-light btn-action"
                            :to="`/live/${item.id}`">
                            <i class="fas fa-pencil-alt"></i>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </List>
              <div class="pagination-container" v-if="isShowPagination()">
                <Pagination :lastPage="lastPage" />
              </div>
            </div>
            <!-- empty list --->
            <EmptyMessage v-if="isEmpty()">
              <h3>ไม่มีข้อมูล</h3>
              <router-link
                class="btn btn-light btn-lg mt-4"
                :to="`/live/create`">
                สร้างวิดีโอถ่ายทอดสด
              </router-link>
            </EmptyMessage>
            <!-- search result -->
            <EmptyMessage v-if="isEmptySearch()">
              <h3>ไม่พบวิดีโอที่ค้นหา</h3>
              <button
                type="button"
                class="btn btn-light btn-lg mt-4"
                @click="clearSearch">
                ล้างการค้นหา
              </button>
            </EmptyMessage>
          </template>
        </Section>
        <!-- error from api -->
        <ErrorMessageVideoContainer
          v-if="loadVideosListState.status === 'error'"
          :error="loadVideosListState.error" />
      </div>
    </div>
  </Page>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
// import { loadCollections } from '@/collection/api';
import dateFormetter from '@/utils/dateFormatter';

import Page from '@/layouts/Page.vue';
import Pagination from '@/components/Pagination.vue';
import Section from '@/components/Section.vue';
import List from '@/components/List.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';
import PreloaderSection from '@/components/PreloaderSection.vue';
import FilterSidebar from '@/components/FilterSidebar.vue';
import ImageView from '@/image/ImageView.vue';
import ManageCollectionItemModal from '@/collection/ManageCollectionItemModal.vue';
// import CollectionSuggestion from '@/collection/CollectionSuggestion.vue';
import ErrorMessageVideoContainer from '@/video/ErrorMessageVideoContainer.vue';

export default {
  mixins: [dateFormetter],
  components: {
    Page,
    Pagination,
    ImageView,
    Section,
    List,
    EmptyMessage,
    ErrorMessageVideoContainer,
    PreloaderSection,
    // CollectionSuggestion,
    FilterSidebar,
    ManageCollectionItemModal,
  },
  data() {
    return {
      pinnedCollections: null,
      selectedStatus: 'all',
      toggleSidebar: false,
      isManageCollectionItemModalShowing: false,
      loadItem: {
        itemId: '',
        collectionType: 'video',
      },
    };
  },
  computed: {
    ...mapState({
      videos: (state) => state.videosList.videos,
      loadVideosListState: (state) => state.videosList.loadVideosListState,
      lastPage: (state) => state.videosList.lastPage,
      contentFilter: (state) => state.filter.filter,
    }),
    filter() {
      return this.$route.query;
    },
    isMultipleUpload() {
      return this.$route.query.multiple;
    },
  },
  watch: {
    filter(newValue) {
      this.loadVideos(newValue);
    },
    isMultipleUpload(multiple) {
      if (multiple) {
        this.loadVideos(this.filter);
      }
    },
  },
  created() {
    this.loadVideos(this.filter);
    // this.loadCollections();
  },
  methods: {
    loadVideos(filter) {
      const query = { ...filter, type: 'live', sourceKey: 'all' };
      this.$store.dispatch('loadVideosList', query);
    },
    clearSearch() {
      this.$store.dispatch('clearFilter');
      this.$router.push({ query: null });
    },
    // async loadCollections() {
    //   const filter = {
    //     isPinned: true,
    //     type: 'video',
    //   };
    //   const response = await loadCollections(filter);
    //   this.pinnedCollections = response.data.data;
    // },
    handleToggleSidebar() {
      this.toggleSidebar = !this.toggleSidebar;
    },
    onSearch(event) {
      this.$store.dispatch('setFilterState', { q: event.target.value });
      if (this.contentFilter.q) {
        this.$router.push({ name: 'liveList', query: { q: this.contentFilter.q, ...this.contentFilter } });
      }
    },
    isEmptySearch() {
      return _.isEmpty(this.videos) && !_.every(this.filter, _.isEmpty);
    },
    isEmpty() {
      return _.isEmpty(this.videos) && _.every(this.filter, _.isEmpty);
    },
    isShowPagination() {
      return this.lastPage > 1;
    },
    getCategoryName(category) {
      return _.get(category, 'name', 'ไม่มีหมวดหมู่');
    },
    onToggleManageCollectionItemModal(itemId) {
      this.loadItem.itemId = itemId;
      this.isManageCollectionItemModalShowing = !this
        .isManageCollectionItemModalShowing;
    },
    onCloseManageCollectionItemModal() {
      this.isManageCollectionItemModalShowing = false;
    },
    getProgramName(program) {
      return _.get(program, 'title', null);
    },
  },
  beforeDestroy() {
    this.$store.dispatch('clearFilter');
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/layouts/page.scss';
@import './src/assets/scss/themes/components/form.scss';

.toggle {
  margin-right: 250px;
  transition: all 0.3s ease-out;
}

.title-information {
  display: flex;
  justify-content: space-between;
  .badge-live {
    padding-top: $spacer * 0.25;
    padding-bottom: $spacer * 0.25;
    font-size: $font-size-base * 0.5;
    width: 26px;
    margin: 0 $spacer * 0.5;
    background-color: lighten($red, 5%);
    color: white;
  }
}

@media (max-width: 575.98px) {
  .toggle {
    margin-right: 0px;
  }
  .playlist-section {
    margin-top: $spacer * 1.5;
    margin-bottom: 0;
    .title-container {
      margin-bottom: $spacer;
      display: flex;
    }
    .playlist-container {
      display: flex;
      .playlist {
        flex: 0 0 85%;
        margin-right: $spacer;
        position: relative;
      }
    }
  }
}

@media (min-width: 576px) and (max-width: 1023.98px) {
  .toggle {
    margin-right: 0px;
  }

  .list-item-container {

    .list-item-detail {
      .list-item {
        &.list-item-status {
          display: none;
        }
        &.list-item-create-at {
          display: none;
        }
        &.list-item-action {
          .action-container {
            .btn-external {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
